import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1ProjectPlanPhaseMilestoneIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";


class ProjectPlanPhaseMilestoneLookupEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();
        let primaryIntegrationComponent = "ProjectPlanPhaseMilestone";

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhaseMilestone-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhaseMilestone-001";

        let QBE = {
            "ShifamedMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                [primaryIntegrationComponent]: {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }

        if (foreignKey) {
            if (this.getEnterpriseObject() !== null) {
                let relationship = this.getRelationshipForChildEnterpriseComponent(this);

                if (relationship) {
                    QBE.ShifamedMessage[primaryIntegrationComponent].QueryGroups.QueryGroup[0].Membership.Member.push({
                        "Type": "Attribute",
                        "Name": relationship.getSourceAttribute(),
                        "Value": foreignKey,
                        "Operator": "EQUAL"
                    })
                }
            }
        }

        if (this.getSearchSpecification() !== null) {
            let keys = Object.keys(this.getSearchSpecification());
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];

                QBE.ShifamedMessage[primaryIntegrationComponent].QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": this.getSearchSpecification()[key],
                    "Operator": "EQUAL"
                })
            }
        }

        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.ShifamedMessage[primaryIntegrationComponent].QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/project_plan_phase_milestones",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default ProjectPlanPhaseMilestoneLookupEnterpriseComponent;